export default async function GetAlterPolicy(
    policyNumber,
    pageNumber,
    query,
    pageSize,
    sortField,
    sort,
    facets) {
    const baseUrl = "/api/TAL/SiteSearch/Documents";

    const constructUrl = () => {
        var origin = "";

        if (window.location.origin === "http://localhost:3000") {
            // note: local testing
            origin = "https://adviser-local.delivery.lan";
        }
        return origin + baseUrl + "?pn=" + pageNumber +
            "&q=" + query +
            "&ps=" + pageSize +
            "&sortfield=" + sortField +
            "&sort=" + sort +
            "&f=" + facets;
    }

    try {
        const response = await fetch(constructUrl(), {
            "method": "GET"
        });

        if (!response) {
            throw Error("No response");
        }
        else if (!response.ok) {
            throw Error(response.statusText);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.log(error);
    }
}